import Vue from 'vue'


//Somente os componentes globais e utilizados sempre
import tPage from "./template/page/t-page"
import tPageTitle from "./template/page/t-page-title"
import tHeader from "./template/page/t-header"
import tFooter from "./template/page/t-footer"
import tDialogConfirm from "./template/dialog/t-dialog-confirm"
import tList from "./template/page/t-list"
import tListActionsDefault from "./template/page/t-list-actions-default"
import tListLinkPrimary from "./template/page/t-list-link-primary"
import tPageGeneral from "./template/page/t-page-general"
import tPageList from "./template/page/t-page-list"
import tPageForm from "./template/page/t-page-form"
import tPageReport from "./template/page/t-page-report"
import tFormCard from "./template/form/layout/t-form-card"
import tFormTab from "./template/form/layout/t-form-tab"
import tPageFormFieldCustomized from "./template/page/t-page-form-field-customized"
import tPagination from "./template/page/t-pagination"
import tContentHeaderSearchDefault from "./template/page/t-content-header-search-default"
import tButton from "./template/theme/t-button/t-button"
import tButtonSave from "./template/theme/t-button/t-button-save"
import tDropdown from "./template/theme/t-button/t-dropdown"
import tInput from "./template/form/input/t-input/t-input"
import tInputStatus from "./template/form/input/t-input-status"
import tInputSearch from "./template/form/input/t-input-search"
import tInputProduct from "./template/form/finder/t-input-product"
import tInputCodeLabel from "./template/form/finder/t-input-code-label"
import tInputPerson from "./template/form/finder/t-input-person"
import tInputStock from "./template/form/finder/t-input-stock"
import tLoading from "./template/theme/t-loading"
import tMsg from "./template/theme/t-msg"
import tHelp from "./template/theme/t-help"
import tProgressBarLine from "./template/theme/t-progress-bar-line"
import tMap from "./template/theme/t-map"
import tBlackout from "./template/theme/t-blackout"
import tWrapped from "./template/theme/t-wrapped"
import tFormWrapped from "./template/form/resource/t-form-wrapped"
import tTable from "./template/theme/t-table"
import tTableField from "./template/theme/t-table-field"
import tReportGenerate from "@/components/template/theme/t-report-generate";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import draggable from 'vuedraggable'

//Calendário de inputs pequenos
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

//Calendário grande aberto (usado em produções, etc)
import Calendar from 'v-calendar/lib/components/calendar.umd'

Vue.component('calendar', Calendar)


//Registrar componentes globais de tamplate e que são muito utilizados
Vue.component('t-page', tPage)
Vue.component('t-page-title', tPageTitle)
Vue.component('t-header', tHeader)
Vue.component('t-footer', tFooter)
Vue.component('t-dialog-confirm', tDialogConfirm)
Vue.component('t-list', tList)
Vue.component('t-list-actions-default', tListActionsDefault)
Vue.component('t-list-link-primary', tListLinkPrimary)
Vue.component('t-page-general', tPageGeneral)
Vue.component('t-page-list', tPageList)
Vue.component('t-page-form', tPageForm)
Vue.component('t-page-report', tPageReport)
Vue.component('t-form-card', tFormCard)
Vue.component('t-form-tab', tFormTab)
Vue.component('t-page-form-field-customized', tPageFormFieldCustomized)
Vue.component('t-content-header-search-default', tContentHeaderSearchDefault)
Vue.component('t-pagination', tPagination)
Vue.component('t-button', tButton)
Vue.component('t-button-save', tButtonSave)
Vue.component('t-dropdown', tDropdown)
Vue.component('t-input', tInput)
Vue.component('t-input-status', tInputStatus)
Vue.component('t-input-search', tInputSearch)
Vue.component('t-input-product', tInputProduct)
Vue.component('t-input-code-label', tInputCodeLabel)
Vue.component('t-input-person', tInputPerson)
Vue.component('t-input-stock', tInputStock)
Vue.component('t-wrapped', tWrapped)
Vue.component('t-loading', tLoading)
Vue.component('t-msg', tMsg)
Vue.component('t-help', tHelp)
Vue.component('t-progress-bar-line', tProgressBarLine)
Vue.component('t-map', tMap)
Vue.component('t-blackout', tBlackout)
Vue.component('t-form-wrapped', tFormWrapped)
Vue.component('t-table', tTable)
Vue.component('t-table-field', tTableField)
Vue.component('t-report-generate', tReportGenerate)
Vue.component('v-select', vSelect)
Vue.component('multiselect', Multiselect)
Vue.component('draggable', draggable)
Vue.component('date-picker', DatePicker)

export default {
    tPage,
    tHeader,
    tFooter,
    tList,
    tListActionsDefault,
    tListLinkPrimary,
    tPagination,
    tContentHeaderSearchDefault,
    tButtonSave,
}




